import React, { useContext, useState } from "react";
import "./My_Account.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Accordion, Nav, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faEllipsisVertical,
  faFilter,
  faPencil,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import Orange_White_Border_Btn from "../../common_components/common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import White_Btn from "../../common_components/common_btn/white_btn/White_Btn";
import Blue_White_Gradient_Btn from "../../common_components/common_btn/blue_white_gradient_btn/Blue_White_Gradient_Btn";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { useNavigate } from "react-router-dom";
import Change_Trading_Password_Modal from "../../common_components/common_modal/change_trading_password_modal/Change_Trading_Password_Modal";
import { Context } from "../../../utils/context";

const My_Account = () => {
  const [key, setKey] = useState("home");

  const [activeKey, setActiveKey] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const { userdata, getuserData, signin } = useContext(Context);

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const navigate = useNavigate();

  return (
    <section className="My_Account">
      <div className="">
        <div className="header_div">
          <Section_Header_Bar />
        </div>

        <p className="section_title">My Account</p>

        <div className="inner_section_box">
          <div className="inner_box">
            <div className="main_data_container">
              <Accordion
                defaultActiveKey="0"
                activeKey={activeKey}
                onSelect={handleToggle}
              >
                <Accordion.Item>
                  <Accordion.Header>
                    <div className="header_holder">
                      <p className="amount_txt">
                        {userdata?.UserWallet?.amount} $
                      </p>

                      <div className="btns_holder">
                        <div className="trade_btn">
                          <Orange_White_Border_Btn
                            btn_name="Trade"
                            onClick={() => {
                              navigate("/trade");
                            }}
                          />
                        </div>
                        <div className="deposit_btn">
                          <Blue_White_Gradient_Btn
                            btn_name="Deposit"
                            onClick={() => {
                              navigate("/deposit");
                            }}
                          />
                        </div>
                        <div className="withdraw_btn">
                          <Blue_White_Gradient_Btn
                            btn_name="Withdraw"
                            onClick={() => {
                              navigate("/withdrawal");
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="arrow_icon_holder">
                      <div className="inner_div">
                        <FontAwesomeIcon
                          style={{
                            marginTop: activeKey === "0" ? "6px" : "0",
                            marginBottom: activeKey !== "0" ? "6px" : "0",
                          }}
                          icon={activeKey === "0" ? faSortUp : faSortDown}
                          className="acc_icon"
                        />
                      </div>
                    </div> */}
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="amount_box">
                      {/* <div className="content_div">
                        <div className="row">
                          <div className="col-lg-6 custom_col">
                            <div className="labels_holder">
                              <p className="label_text">Unrealized P&L</p>
                              <p className="value_text">0.00 USD</p>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="labels_holder">
                              <p className="label_text">Free margin</p>
                              <p className="value_text">0.00 USD</p>
                            </div>

                            <div className="labels_holder">
                              <p className="label_text">Equity</p>
                              <p className="value_text">0.00 USD</p>
                            </div>
                          </div>
                        </div>
                      </div> */}

                      {/* <div className="accordio_footer">
                        

                        <div className="change_password">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              icon={faPencil}
                              className="copy_icon"
                            />
                          </div>
                          <p
                            className="text"
                            onClick={() => {
                              setShowModal(true);
                            }}
                          >
                            Change Trading Password
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          <div className="footer_text">
            <Inner_Footer_Text_Component />
          </div>
        </div>
      </div>

      <Change_Trading_Password_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default My_Account;
